import React, { Component } from 'react'

export default class OnboardingReroute extends Component {
  componentWillMount () {
    this.props.history.push('/onboarding')
  }

  render () {
    return <div />
  }
}
